import quickFetch from 'quick-fetch';
import { renderRoot } from 'quartz-core/client';
import PortalIdParser from 'PortalIdParser';

//I18n Configuration
import createPublicI18nProvider from 'I18n/init/providers/createPublicI18nProvider';
import registerAllData from 'I18n/init/register/sync/registerAllData';
import lang from 'i2l?query=sporks!documents-lib/lang/view/en.lyaml';
import 'I18n/init/data/baseLocales';
import 'I18n/init/data/publicLocales';
import setDocumentTitle from 'I18n/utils/setDocumentTitle';
import { Provider } from 'react-redux';
import { initTracker } from 'documents-lib/js/tracking/tracker';
import { getBrowserLanguage } from 'documents-lib/js/utils/getBrowserLanguage';
import { configureStore } from './utils/configureStore';
import { RhumbProvider } from 'react-rhumb';
import rhumbConfig from '../rhumb-config.yaml';
import { createBrowserHistory } from 'history';
import historyAdapter from 'react-rhumb/historyAdapterV4';
import { ViewApplication } from './containers/ViewApplication';
import { fetchPresentationSuccess, fetchDocumentsLegalConsentSuccess, documentsGDPRLangLoading } from './actions/DocumentsPublicActions';
import PresentationRecord from 'documents-lib/js/records/PresentationRecord';
import LegalConsentRecord from 'documents-lib/js/records/LegalConsentRecord';
import { ensureGdprLang } from './utils/ensureGdprLang';
import { needsToLoadLocale } from './utils/needsToLoadLocale';
import UIApplication from 'UIComponents/app/UIApplication';
import { jsx as _jsx } from "react/jsx-runtime";
export default class Application {
  start() {
    if (window.jasmine) return;
    window.AppInstance = this;
    this.init().then(() => {
      setDocumentTitle('app.htmlTitle');
      this.startRedux();
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  }
  init() {
    PortalIdParser.get();
    const browserLanguage = getBrowserLanguage();
    const I18nProvider = createPublicI18nProvider({
      manuallySetLocale: true
    });
    const langAvailable = Promise.all([I18nProvider.register(lang), registerAllData(I18nProvider)]);
    I18nProvider.setLocale({
      locale: browserLanguage,
      langEnabled: true
    });
    return langAvailable;
  }
  getEarlyRequestData() {
    const presentationRequestState = quickFetch.getRequestStateByName('public-presentation');
    const presentationRequestReady = presentationRequestState && presentationRequestState.finished && !presentationRequestState.error;
    if (presentationRequestReady) {
      this.store.dispatch(fetchPresentationSuccess(PresentationRecord.create(presentationRequestState.data)));
      initTracker({
        isPublic: true
      });
    }
    const legalConsentRequestState = quickFetch.getRequestStateByName('public-legal-consent');
    const consentRequestReady = legalConsentRequestState && legalConsentRequestState.finished && !legalConsentRequestState.error;
    if (consentRequestReady) {
      this.store.dispatch(documentsGDPRLangLoading());
      const consentRecord = LegalConsentRecord.fromJS(legalConsentRequestState.data);
      const needsFallbackLocale = needsToLoadLocale(consentRecord);
      if (!needsFallbackLocale) {
        this.store.dispatch(fetchDocumentsLegalConsentSuccess(consentRecord));
      } else {
        ensureGdprLang(consentRecord).then(() => {
          this.store.dispatch(fetchDocumentsLegalConsentSuccess(consentRecord));
        }).catch(console.error);
      }
    }
  }
  startRedux() {
    this.store = configureStore({});
    this.getEarlyRequestData();
    this.renderApp();
  }
  renderApp() {
    const history = createBrowserHistory({
      basename: `/documents/${PortalIdParser.get()}`
    });
    renderRoot( /*#__PURE__*/_jsx(UIApplication, {
      name: "documents-public-ui",
      children: /*#__PURE__*/_jsx(RhumbProvider, {
        config: rhumbConfig,
        history: historyAdapter(history),
        children: /*#__PURE__*/_jsx(Provider, {
          store: this.store,
          children: /*#__PURE__*/_jsx(ViewApplication, {})
        })
      })
    }));
  }
}